import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';

import { enUS } from 'date-fns/locale/en-US';
import { enGB } from 'date-fns/locale/en-GB';

import { observer } from 'mobx-react-lite';
import { Locale } from 'date-fns';

import { de } from 'date-fns/locale/de';

const customEnLocale: Locale = {
  ...enGB,
  options: {
    ...enGB.options,
    weekStartsOn: 1,
  },
  ...enUS,
};

const LocalizationWrapper = observer(
  ({ children }: { children: React.ReactNode }) => {
    const lang = localStorage.getItem('i18nextLng') || 'de';
    return (
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={lang === 'de' ? de : customEnLocale}
      >
        {children}
      </LocalizationProvider>
    );
  },
);

export default LocalizationWrapper;
